import { styled } from 'baseui';
export const VSpacer = styled('div', ({
  $theme
}) => ({
  marginBottom: $theme.sizing.scale400
}));